import React, { useEffect, useState, useRef } from "react";
import "./roadmap.scss";

const images = [
  "/assets/roadmapassets/roadmapone.png",
  "/assets/roadmapassets/roadmaptwo.png",
  "/assets/roadmapassets/roadmapthree.png",
  "/assets/roadmapassets/roadmapfour.png",
  "/assets/roadmapassets/roadmapfive.png",
  "/assets/roadmapassets/roadmapsix.png",
  "/assets/roadmapassets/roadmapseven.png",
];
const circlePositions = [0, 300, 580, 848, 1190, 1460, 1753];

const Sevenphases = () => {
  const [activePhase, setActivePhase] = useState(0);
  const roadmapRef = useRef(null);
  const thumbRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!roadmapRef.current || !thumbRef.current) return;

      const sectionTop = roadmapRef.current.offsetTop;
      const sectionHeight = roadmapRef.current.offsetHeight;
      const viewportHeight = window.innerHeight;
      const scrollY = window.scrollY;

      // Calculate progress relative to the roadmap section
      let progress = (scrollY - sectionTop) / (sectionHeight - viewportHeight);
      progress = Math.min(Math.max(progress, 0), 1); // Clamp between 0 and 1

      // Extend thumb position by 300px
      const minThumbPosition = circlePositions[0]; // First position
      const maxThumbPosition = circlePositions[circlePositions.length - 1] + 205; // Add 300px
      const thumbPosition = minThumbPosition + progress * (maxThumbPosition - minThumbPosition);

      // Update thumb position
      thumbRef.current.style.top = `${thumbPosition}px`;

      // Detect closest phase dynamically
      let closestPhase = 0;
      for (let i = 0; i < circlePositions.length; i++) {
        if (thumbPosition >= circlePositions[i]) {
          closestPhase = i;
        }
      }

      setActivePhase(closestPhase);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);



  return (
    <section className="sevenphasesmain" ref={roadmapRef}>
      <h4 className="sevenphaseshead">What’s Coming Next</h4>
      <div className="innersevenphases">
        {/* Image Container */}
        <div className="mainphasesimg">
          <div className="phasesimg">
            <img src={images[activePhase]} alt={`Phase ${activePhase + 1}`} className="innerphasesimg  d-noneonmobile" />
            <img src='/assets/roadmapassets/roadmapone.png' className="innerphasesimg d-blockonmobile d-none" />
          </div>
        </div>

        {/* Scroll Track */}
        <div className="scrollermain">
          <span className="thumb" ref={thumbRef}></span>
          {Array.from({ length: 7 }).map((_, index) => (
            <span key={index} className={`circle circle${index + 1}`}></span>
          ))}
        </div>

        {/* Text Phases */}
        <div className="phasestextsmain">
          <div className="phasestext">
            <p className="phasepara">Q2 2025  </p>
            <h4 className="phasehead">– Beta Launch</h4>
            <ul>
              <li>
                Messaging & crypto in one interface (1:1 and group chats)               </li>
              <li>
                Integrated wallet (non-custodial, multi-chain)
              </li>
              <li>
                Content monetization features
              </li>
              <li>
                Referral system
              </li>
              <li>
                Walletless onboarding via DIDs
              </li>

            </ul>
          </div>
          <div className="phasestext">
            <p className="phasepara">Q3 2025 </p>
            <h4 className="phasehead">– Identity & Reputation Layer</h4>
            <ul>
              <li>
                Community management tools



              </li>
              <li>
                Mini-apps portal (initial version)


              </li>
              <li>
                Peer-to-peer marketplace
              </li>
            </ul>
          </div>
          <div className="phasestext">
            <p className="phasepara">Q4 2025 </p>
            <h4 className="phasehead">– Ecosystem Expansion</h4>
            <ul>
              <li>
                SDK for third-party mini-app integrations (v1)
              </li>
              <li>
                Location-based groups by interest
              </li>
            </ul>
          </div>
          <div className="phasestext">
            <p className="phasepara"> 2026 </p>
            <h4 className="phasehead">–  Governance, Developer Tools & Monetization</h4>
            <ul>
              <li>
                DAO tools for community-led decisions
              </li>
              <li>
                SDK evolution with advanced capabilities (v2+)
              </li>
               <li>
                Broader ecosystem integrations
              </li>
              <li>
                Subscription infrastructure for premium features (Plus / Creator plans)
              </li>
            </ul>
          </div>
          {/* <div className="phasestext">
            <p className="phasepara">Phase 5 (Q1 2026)</p>
            <h4 className="phasehead"> -Web3 Governance Tools</h4>
            <ul>
              <li>
                Integration of decentralized governance capabilities and DAO tools to empower community decision-making.
              </li>
            </ul>
          </div> */}
          {/* <div className="phasestext">
            <p className="phasepara">Phase 6 (Q2 2026)</p>
            <h4 className="phasehead">Developer Ecosystem</h4>
            <ul>
              <li>
                Introduction of a developer portal with tools for building decentralized apps, including SDKs and open-source integration capabilities.
              </li>
            </ul>
          </div>
          <div className="phasestext">
            <p className="phasepara">Phase 7 (Q3 2026)</p>
            <h4 className="phasehead">Enhanced Communication</h4>
            <ul>
              <li>
                Decentralized voice call functionality and support for individual and group video calls to improve collaboration.
              </li>
            </ul>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default Sevenphases;